import TemplateSurveyState from 'containers/SurveyPage/TemplateSurveyState';
import { transformPropsDeep, escapeHTML } from 'containers/App/utils';
import { find, get } from 'lodash';
import {
  getConceptIds,
  getAttributeIds,
} from 'containers/QuestionnairePage/QuestionGroup/utils';
import {
  mapQuestionsAndGroupsAsNodes,
  duplicateQuestion as duplicateQuestionHelper,
} from 'containers/QuestionnairePage/utils';
import { SURVEY_TYPE_PEEQ } from 'containers/Survey/constants';
import { AB_TEST_TYPES } from '../constants';

const logoTestingGenerator = ({ template, variables, surveyType }) => {
  // pass the fetchedXXXX options only
  // if you intend to use the relevant template as-is

  const Survey = new TemplateSurveyState({
    // fetchedQuestionnaire: template.questionnaireTemplate,
    fetchedTargeting:
      surveyType === SURVEY_TYPE_PEEQ
        ? template.peeqTargetingTemplate
        : template.regularTargetingTemplate,
  });

  // extract and prepare user variables
  const abTestType = get(
    find(variables, ['name', 'ab_test_type']),
    'value',
    AB_TEST_TYPES.SEQUENTIAL,
  );

  const yourBrand = get(find(variables, ['name', 'your_brand']), 'value', '');
  const replaceBrandText = (value) =>
    value.replace(/\{\{your_brand\}\}/gi, escapeHTML(yourBrand));

  const concepts = get(find(variables, ['name', 'concepts']), 'value', []).map(
    (concept) => ({ ...concept, text: `<div>${concept.text}</div>` }),
  );
  const repetitions =
    abTestType === AB_TEST_TYPES.MONADIC ? 1 : concepts.length;

  const questionnaireTemplate = transformPropsDeep(
    template.questionnaireTemplate,
    { prompt: replaceBrandText, htmlPrompt: replaceBrandText },
  );

  const { nodes: logoTestingTemplateQuestions } = mapQuestionsAndGroupsAsNodes(
    questionnaireTemplate,
  );

  const ABTestGroupQuestion = duplicateQuestionHelper(
    logoTestingTemplateQuestions[0],
  );

  Survey.questionnaire.addQuestion(ABTestGroupQuestion);

  // CLEAN UP
  // Remove Concepts and Attributes
  const abTestConceptIds = getConceptIds(ABTestGroupQuestion);
  const attributesIds = getAttributeIds(ABTestGroupQuestion);

  abTestConceptIds.forEach((conceptId) => {
    Survey.questionnaire.removeAbConcept({
      refId: ABTestGroupQuestion.refId,
      conceptRefId: conceptId,
    });
  });
  attributesIds.forEach((attributeId) => {
    Survey.questionnaire.removeGroupAttribute({
      refId: ABTestGroupQuestion.refId,
      attributeRefId: attributeId,
      groupType: ABTestGroupQuestion.type,
    });
  });

  // SET UP
  // add user concepts
  concepts.forEach((concept) => {
    const conceptRefId = Survey.questionnaire.addAbConcept(
      ABTestGroupQuestion.refId,
    );
    if (conceptRefId) {
      Survey.questionnaire.updateAbConcept({
        refId: ABTestGroupQuestion.refId,
        conceptRefId,
        name: concept.name,
      });
    }
  });

  // add attribute and attribute values
  const abAttribute = Survey.questionnaire.addGroupAttribute({
    refId: ABTestGroupQuestion.refId,
    name: '',
    type: '',
    groupType: ABTestGroupQuestion.type,
  });

  concepts.forEach((concept, conceptIndex) => {
    const attributeValue = abAttribute.values[conceptIndex];

    Survey.questionnaire.updateGroupAttributeValue({
      refId: ABTestGroupQuestion.refId,
      attributeRefId: abAttribute.refId,
      attributeValueRefId: attributeValue.refId,
      text: concept.text,
      media: concept.media,
    });
  });

  // set AB type (monadic/sequential)
  Survey.questionnaire.updateAbProperties({
    refId: ABTestGroupQuestion.refId,
    properties: { repetitions },
  });

  return { state: Survey.state };
};

export default logoTestingGenerator;
